import { BetConstructIntegration } from './betconstruct';
import { FuturePlayIntegration } from './future-play';
import { DefaultIntegration } from './default';
import { BetfairIntegration } from './betfair';
import { CashierIntegration } from './cashier';
import { MonitorIntegration } from './monitor';
import { ReplayIntegration } from './replay';
import { VirtualIntegration } from './virtual';
import { RelaxIntegration } from './relax';
import { LaunchType } from '../../enums';
import { IntegrationBase } from './base';
import { RootStore } from '../../store';

class IntegrationStrategy {

  public current!: IntegrationBase;

  private readonly integrations: Partial<Record<LaunchType, typeof IntegrationBase>> = {
    [LaunchType.Pascal]: DefaultIntegration,
    [LaunchType.BetConstruct]: BetConstructIntegration,
    [LaunchType.Futureplay]: FuturePlayIntegration,
    [LaunchType.Relax]: RelaxIntegration,
    [LaunchType.Betfair]: BetfairIntegration,
    [LaunchType.Cashier]: CashierIntegration,
    [LaunchType.Monitor]: MonitorIntegration,
    [LaunchType.Replay]: ReplayIntegration,
    [LaunchType.Virtual]: VirtualIntegration,
  };

  init(key: LaunchType, rootStore: RootStore) {
    const LaunchConstructor = this.integrations[key] || DefaultIntegration;
    this.current = new LaunchConstructor(rootStore);
  }

}

export const integration = new IntegrationStrategy();
